import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface ForbiddenStateProps {
  title?: string;
  message?: string;
}

export function ForbiddenState({ title, message }: ForbiddenStateProps) {
  return (
    <Box className="page-state forbidden-state" role="alert" sx={{ textAlign: 'center', p: 4 }}>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">{message}</Typography>
    </Box>
  );
}
